import React from "react";
import {Tooltip} from "antd";
import {CrownFilled} from "@ant-design/icons";
import {CopyableSpan, TableDoubleValueCell} from "../../components/index.jsx";

export const filterBriefsBySearchInput = (briefs, searchInput) => {
    if (!searchInput) {
        return briefs;
    }

    return briefs?.filter(brief => {
        const relevantBriefs = [brief];

        return relevantBriefs.some(
            brief =>
                [
                    "maxPrice",
                    "address",
                    "description",
                    "systemId",
                    "providerIds",
                    "status",
                    "contactName",
                    "companyName",
                    "companyContactName",
                    "companyContactEmail",
                    "companyPhone",
                    "briefNumber"
                ].some(key => String(brief[key])?.toLowerCase().includes(searchInput.toLowerCase())) ||
                searchInput === brief.briefId ||
                brief.assignedCSMs?.some(({email}) => email === searchInput.toLowerCase())
        );
    });
};

export const CompanyDetails = ({
    isCompanySubAdmin,
    isCompanyMaster,
    companyContactName,
    contactName,
    companyPhone,
    companyContactEmail,
    creatingBehalfUserId,
    companyName
}) => {
    return (
        <TableDoubleValueCell>
            {creatingBehalfUserId ? companyName + "🖐️" : companyName}
            <div className="names-order-details">
                <Tooltip placement="topRight" title={isCompanySubAdmin ? ` אדמין ראשי: ${contactName}` : null}>
                    <span>{companyContactName}</span>
                    {isCompanyMaster && <CrownFilled title="אדמין ראשי" className="admin-order-crown-filled" />}
                </Tooltip>
                {companyPhone && <span>{companyPhone}</span>}
                <CopyableSpan>{companyContactEmail}</CopyableSpan>
            </div>
        </TableDoubleValueCell>
    );
};
